import { memo } from 'react'
import { useClientDetails } from 'stores/utils/hooks/useClientDetails'

const GuenstigerGehtNicht = () => {
  const clientDetails = useClientDetails()

  return (
    <img
      src={clientDetails?.logos?.guenstigerGehtNicht}
      alt="Ausgezeichnete Kundenzufriedenheit Logo"
      loading="lazy"
      height="64px"
    />
  )
}

export default memo(GuenstigerGehtNicht)
